module.exports = __webpack_public_path__ + "static/home-phone1-b04e57d0336aba1acfb9b28c93132b0b.png";